import { useLocation } from '@Alias/hooks';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setIsFASTSignUp } from '../../redux/actions/billing';
import { getIsFASTSignUp } from '../../redux/selectors/billing';
import { AUTHENTICATE_NESTED, AUTHORIZE_NESTED, SIGNUP_NESTED } from '../../utils/router';

export const VALID_FAST_PATHS = [SIGNUP_NESTED, AUTHORIZE_NESTED, AUTHENTICATE_NESTED];

/** SC
 * 
 * For the FAST front-of-paywall experiment:
 * Users who are in the experiment variant group will be presented with
 * the FAST experiment UI on the Welcome page (a "Free" filter added to
 * the Channel Search section, and an experiment specific component to
 * replace the Free channel line ups displayed). Variant cohort will
 * enter the FAST experiment "flow" when click on "Watch free
 * channels" button from the experiment component.

 * Analytics prefer to track this user flow via page events. Once FAST
 * CTA is clicked, isFastSignUp flag is set to true, and page track
 * event titles will have "FAST" appended to the beginning.
 * (ie Signup -> FASTSignUp, Authenticate -> FASTAuthenticate).

 * FAST experiment flow will skip package selection and payment collection.
 * HAPPY FLOW: /signup or /authenticate -> /authorize -> assign FAST
 * preference -> route to product. New FAST user will be in KNOWN state with
 * FAST enabled.

 * This hook resets the isFASTSignup flag when a user "exits" the FAST flow.
 */
export function useFASTSignupFlowTracker() {
  const isFASTSignUp = useSelector(getIsFASTSignUp);
  const location = useLocation();
  const { pathname } = location;
  const prevPathRef = useRef(pathname);
  const dispatch = useDispatch();

  useEffect(() => {
    const prevPath = prevPathRef.current;
    const wasInFASTFlowPaths = isFASTSignUp && VALID_FAST_PATHS.includes(prevPath);

    if (wasInFASTFlowPaths && !VALID_FAST_PATHS.includes(pathname)) {
      dispatch(setIsFASTSignUp(false));
    }
    prevPathRef.current = pathname;
  }, [pathname]);
}
